import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalHeader } from "../ModalHeader";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useState } from "react";
import { Alert, Autocomplete, Divider, Grid, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import { ModalFooter } from "../ModalFooter";
import '../../../assets/styles/modals.scss';
import { Loading } from "@/components/common/Loading";
import { Props } from "./ModalBranchOfficeType.type";
import { branchOfficeService } from "@/service/services/BranchOffice.service";
import ___PHRASE from "@/service/translate/translateService";
import { apiResponseTranslate } from "@/toolbox/helpers/responseApi.helper";


export const ModalBranchOfficeType: React.FC<Props> = (props:any): JSX.Element => {

    const { open, closeModal, actionSelected, branchOfficeType, onListTypes, clearState } = props;

    const [loading, setLoading] = useState<boolean>(false);

    const [data, setData] = useState({
        name: branchOfficeType ? branchOfficeType.name : '',
    });

    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });

    const validateForm = (values) => {
        let errors: any = {};
        if(!values.name) errors.name = "nombre requerido";
        if(values.name.length > 50) errors.name = "máximo 50 caracteres"
        return errors;
    }

    const onSubmit = async(values, {resetForm})  => {

        const formData = {
            id: values.id,
            name: values.name,
        }
        setLoading(true);
        if(branchOfficeType && actionSelected=='edit'){
            await branchOfficeService.updateTypeBranchOffice(formData, branchOfficeType.id).then((data) => {
                let apimessagge = apiResponseTranslate(data?.data?.message || '');

                if(data.data.status){
                    setSnackBarConfig({...snackBarConfig, open: true, severity: 'success', message: apimessagge})
                }else{
                    setSnackBarConfig({...snackBarConfig, open: true, severity: 'error', message:apimessagge})
                }
                setTimeout(()=>{
                onListTypes && onListTypes();
                closeModal && closeModal();
                 },2000)

            })
        }else{
            await branchOfficeService.createTypeBranchOffice(formData).then((data) => {
                let apimessagge = apiResponseTranslate(data?.data?.message || '');

                if(data.data.status){
                    setSnackBarConfig({...snackBarConfig, open: true, severity: 'success', message: apimessagge})
                }else{
                    setSnackBarConfig({...snackBarConfig, open: true, severity: 'error', message:apimessagge})
                }
                setTimeout(()=>{
                onListTypes && onListTypes();
                closeModal && closeModal();
                 },2000)
            })
        }
        setLoading(false);
    }

    return(
        <>
        {loading && <Loading/>}

        <Snackbar
            open={snackBarConfig.open} 
            autoHideDuration={snackBarConfig.autoHideDuration} 
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                {snackBarConfig.message || ""}
            </Alert>
        </Snackbar>

        <Modal open={open} handleClose={closeModal} handle size="sm">
            <ModalHeader
                text={((branchOfficeType && actionSelected=='edit') ? ___PHRASE("editar") : ___PHRASE("agregar"))+' '+___PHRASE("tipoDeSucursal")}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) =>{
                        return(
                            <form onSubmit={handleSubmit}>
                                <Grid container >
                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>{___PHRASE("nombre")}:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="name"
                                            variant="standard"
                                            type="text" 
                                            name="name"
                                            fullWidth
                                            value={values.name}
                                            onChange={handleChange}
                                            placeholder={___PHRASE("nombre")}
                                            error={(errors.name) && touched.name ? true : false}
                                            helperText={(errors.name) && touched.name ? errors.name : ''}
                                        />
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={(branchOfficeType && actionSelected=='edit') ? ___PHRASE("actualizar") : ___PHRASE("registrar")}
                                    cancelText={___PHRASE("cancelar")} 
                                    onCancel={closeModal}
                                    clearState={clearState}
                                    onConfirm={handleSubmit}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
        </>
    );
}